module.exports = __webpack_public_path__ + "static/img/dy.5b0c087.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dy.png
// module id = iUG8
// module chunks = 1